// https://vuex.vuejs.org/en/mutations.html

export default {
  //
  SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_VENDORS(state,data){
      state.vendors=data
    },
    SET_VID(state,data){
      state.vid=data
    },
}
